/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { en, it } from 'vuetify/src/locale';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdiSvg',
    },
    lang: {
        current: 'en',
        locales: {
            en,
            it,
        },
    },
    theme: {
        dark: false,
        themes: {
            dark: {
                primary: '#4F5D75',
                secondary: '#CACFD6',
                accent: '#A6B1E1',
                error: '#EF233C',
                warning: '#F2AA4C',
                info: '#4F86C6',
                success: '#6BBE92',
            },
            light: {
                primary: '#212121',
                secondary: '#757575',
                accent: '#FFC107',
                error: '#FF5252',
                warning: '#FFC107',
                info: '#2196F3',
                success: '#4CAF50',
            },
        },
    },
});
